import * as React from 'react';
import { AScene } from '@eagerlogic/react-mvc';
import { TeamHolidaysModel } from '../model/TeamHolidaysModel';
import { TeamHolidaysController } from '../controller/TeamHolidaysController';
import { Paper } from 'components/paper';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import { ISceneFactory } from 'scenes/ISceneFactory';
import { HistoryItem } from 'utils/Navigation';

export class TeamHolidaysScene extends AScene<{ year?: number }, TeamHolidaysModel, TeamHolidaysController> {

    protected createControlller(): TeamHolidaysController {
        return new TeamHolidaysController(this.props.year);
    }

    public render(): React.ReactNode {
        return (
            <div style={{ width: '100%', padding: '64px' }} >
                <Paper title="Team holiday statistics">
                    <Table style={{ width: '100%' }}>
                        <TableHead>
                            <TableRow>
                                <TableCell >Name</TableCell>
                                <TableCell padding="none">Annual</TableCell>
                                <TableCell padding="none">Carried</TableCell>
                                <TableCell padding="none">Used</TableCell>
                                <TableCell padding="none">Remaining</TableCell>
                                {this.model.extraTitles.map((item, index) => {
                                    return (
                                        <TableCell key={"th-" + index} padding="none">{item}</TableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.model.items.map((item, index) => {
                                return (
                                    <TableRow key={"tr-" + index}>
                                        <TableCell>{item.userName}</TableCell>
                                        <TableCell padding="none">{item.yearlyVacationCount}</TableCell>
                                        <TableCell padding="none">{item.rolledVacationCount}</TableCell>
                                        <TableCell padding="none">{item.usedUpVacationCount}</TableCell>
                                        <TableCell padding="none">{item.remainingVacationCount}</TableCell>
                                        {item.otherItems.map((oi, oidx) => {
                                            return (<TableCell key={"trc-" + oidx} padding="none">{oi}</TableCell>);
                                        })}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </Paper>
            </div>
        );
    }

}

export class TeamHolidaysSceneFactory implements ISceneFactory {

    public create(historyItem: HistoryItem): React.ReactNode {
        var yStr = historyItem.params["y"]
        var y = null;
        if (yStr != null) {
            y = parseInt(yStr)
        }
        return (
            <TeamHolidaysScene year={y} />
        );
    }

}